<!-- 领取成功 -->
<template>
  <div class="headerPage">
    <!-- <Header header-title="领取优惠券" /> -->
    <div class="header">
      <van-icon name="arrow-left" class="arrow_left" alt="" @click="goBack" />
      <span>领取优惠券</span>
      <div style="width:21px"></div>
    </div>
    <div class="top">
      <img src="@/assets/get_success.png" alt="">
    </div>
    <div class="top_success">
      <img src="@/assets/icon_success.png" alt="">
    </div>
    <div class="suc_msg">恭喜你领取成功!</div>
    <div class="content">
      <p>优惠券已放入您的手机号{{ query.mobile }}登录的<span>{{ short_name }}账户中</span></p>
      <p class="expire_days">优惠券有效期{{ query.expire_days }}天,请立即使用</p>
    </div>
    <div class="btn_box">
      <van-button block round color="linear-gradient(to right, #FFEFCA, #FEE6B8)" @click="go_coupon">
        <span style="color:#6C4124;display: inline-block;margin-top: 4px">查看我的优惠券</span>
      </van-button>
      <van-button block round color="linear-gradient(133deg, #F76262 0%, #EE2E2E 100%)" @click="btnClick">
        <span style="color:white;display: inline-block;margin-top: 4px">立即使用</span>
      </van-button>
    </div>

  </div>
</template>

<script>
// import Header from '@/components/header'
import { getAgencyInfo, getAgencyAppList } from '@/api/bbsCoupon.js'
import { getUrl } from '@/api/ucenterCouponTwo.js'
import Cookies from 'js-cookie'
export default {
  name: '',
  // components: { Header },

  data() {
    return {
      query: {},
      btnText: '',
      short_name: '',
      content: '',
      lesson_url: '',
      pay_url: '',
      right_name: '',
      use_type: '',
      type_id: '',
      lesson_id: '',
      
      seeMyCouponUrl: '',
      // 去购买e会员、v会员的id
      e_v_buy_id: ''
    }
  },

  computed: {},

  created() {
    this.query = this.$route.query
    console.log(this.query)
    this.right_name = this.query.coupon_type_name
    this.use_type = this.query.use_type
    this.type_id = this.query.type_id
    this.lesson_id = this.query.lesson_id
    this.e_v_buy_id = this.query.e_v_id || ''
    // switch (this.query.coupon_type_name) {
    //   case '训练营优惠券':
    //     this.btnText = '立即购买课程'
    //     break
    //   case '视频课优惠券':
    //     this.btnText = '立即购买课程'
    //     break
    //   case 'VIP优惠券':
    //     this.btnText = '升级VIP会员'
    //     break
    //   case '社区优惠券':
    //     this.btnText = '升级社区会员'
    //     break
    //   default:
    //     this.btnText = '立即使用'
    //     break
    // }
    this.getAgencyInfo()
    this.getAgencyAppList()
    this.getUrl()
  },

  mounted() {},

  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getUrl() {
      getUrl().then(res => {
        if (res.errNo == 0) {
          this.seeMyCouponUrl = res.result.h5_url
        }
      })
    },
    go_coupon() {
      // console.log('查看优惠券')
      // window.location.href = window.origin + '/ucenter/index/coupon'
      // window.location.href = window.origin + '/mine/coupon'
      window.location.href = this.seeMyCouponUrl
    },
    // 立即使用
    btnClick() {
      if (this.isToLogin()) {
        if (this.lesson_id == '-1') {
          // 通用券
          // if (this.use_type == '0') {
          //   // 训练营
          //   // window.location.href = window.origin + '/edu?type=2'
          //   window.location.href = window.origin + '?type=2'
          // } else {
          //   // window.location.href = window.origin + '/edu?type=1'
          //   window.location.href = window.origin + '?type=1'
          // }
          window.location.href = window.origin + '/'
        } else {
          switch (this.use_type) {
            case '2':
              window.location.href = window.origin + '/buyMember?product_type=3&id=' + this.e_v_buy_id + '&only=1'
              break
            case '3':
              window.location.href = window.origin + '/buyMember?product_type=2&id=' + this.e_v_buy_id + '&only=1'
              break
            case '5':
              window.location.href = window.origin + `/bookInfo?book_id=${this.lesson_id}`
              break
            default:
              window.location.href = this.lesson_url
              break
          }
        }
      }
      // if (this.isToLogin()) {
      //   switch (this.right_name) {
      //     case '训练营优惠券':
      //       window.location.href = this.lesson_url
      //       break
      //     case '精品课优惠券':
      //       window.location.href = this.lesson_url
      //       break
      //     case 'VIP会员优惠券':
      //       window.location.href = window.origin + '/pay/?product_type=3'
      //       break
      //     case '社区会员优惠券':
      //       window.location.href = window.origin + '/pay/?product_type=2'
      //       break
      //     default:
      //       break
      //   }
      // }
    },
    getAgencyInfo() {
      getAgencyInfo().then(res => {
        console.log(res, 'res')
        this.short_name = res.result.name
        if (res.result.agency_id == 2) {
          // this.lesson_url = window.origin + '/edu'
          this.lesson_url = window.origin + `/shop/pay/?product_type=1&product_id=${this.$route.query.lesson_id}&fromurl=coupon`
        } else {
          // this.lesson_url = window.origin + '/selectSubject'
          this.lesson_url = window.origin + `/home?lesson_id=${this.lesson_id}`
        }
      })
    },
    getAgencyAppList() {
      getAgencyAppList().then(res => {
        console.log(res, 'res')
        this.content = res.result[0].name
        console.log(this.content, 'content')
      })
    },
    // 重定向到登录
    isToLogin() {
      // var url = location.href
      var url = ''
      if (this.lesson_id == '-1') {
        // 通用券
        // if (this.use_type == '0') {
        //   // 训练营
        //   // window.location.href = window.origin + '/edu?type=2'
        //   url = window.origin + '?type=2'
        // } else {
        //   // window.location.href = window.origin + '/edu?type=1'
        //   url = window.origin + '?type=1'
        // }
        url = window.origin + '/'
      } else {
        switch (this.use_type) {
          case '2':
            // window.location.href = window.origin + '/shop/pay/?product_type=3'
            url = window.origin + '/buyMember?product_type=3'
            break
          case '3':
            // window.location.href = window.origin + '/shop/pay/?product_type=2'
            url = window.origin + '/buyMember?product_type=2'
            break
          case '5':
            url = window.origin + `/bookInfo?book_id=${this.lesson_id}`
            break
          default:
            url = this.lesson_url
            break
        }
      }
      if (!Cookies.get('uid') || !Cookies.get('username')) {
        if (process.env.NODE_ENV === 'development') {
          window.open(
            window.origin + `/login?redirect=${url}`,
            '_self'
          )
        } else {
          window.open(
            window.origin + `/login?redirect=${url}`,
            '_self'
          )
        }
        return false
      } else {
        return true
      }
    }
  }
}

</script>
<style lang='less' scoped>
  p{
    margin: 0;
    padding: 0;
  }
.btn_box{
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .van-button{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48.5%;
  }
}
.headerPage{
  // position: fixed;
  // top: 0;
  // left: 0;
  margin:  0 auto;
  min-height: 100vh;
  z-index: 1000;
  background: #F0F0F0;
}
.header{
  width: 760px;
  padding: 0 10px;
  position: absolute;
  top:56px;
  color:#fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  font-size: 50px;
  .arrow_left{
    font-size: 64px;
  }
}
.top_success{
  margin: -150px auto 0;
  width: 260px;
  height: 260px;
  img{
    display: block;
    width: 100%;
    height: 100%;
  }
}
.page_header{
    height: 160px;
    line-height: 160px;
    border-bottom: 1px solid #ddd;
    padding: 0 50px 0 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title{
        font-size: 68px;
        // font-weight: 600;
    }
    .arrow_left{
      width: 48px;
      height: 84px;
    }
    .more_icon{
      width: 84px;
      height: 60px;
      // margin-right: 80px;
      margin-right: 0px;
    }
}
.top{
  img{
    // width: 750px;
    // height: 243px;
    width: 100%;
    height: 100%;
  }
}
.suc_msg{
  color: #939393;
  font-size: 40px;
  margin: 70px 0 20px;
  text-align: center;
}
.content{
  color: #939393;
  text-align: center;
  font-size: 36px;
  margin-bottom: 206px;
  p{
    margin-bottom:20px;
  }
  .expire_days{
    color:#ee2e2e;
    font-size: 36px;
  }
}
.btn{
  width: 1300px;
  height:176px;
  line-height: 176px;
  text-align: center;
  background: #EE2E2E;
  border-radius: 86px;
  margin: 86px auto;
  font-size: 72px;
  color: #fff;
}
</style>
